import React, { Fragment, useState } from 'react';
import { connect } from 'react-redux';
import { compose, withApollo } from 'react-apollo';
import {
  SubjectSelector,
  UserMenu,
  QuickTips,
  HelpMenu,
  AcademicYearSelector,
  LoadingSpinner,
} from 'legacy-packages/ft-cb';
import { getSubjectEducationPeriods } from 'legacy-src/components/auth/utils';
import { setDefaultEducationPeriodCode as setDefaultEducationPeriodCodeAction } from 'legacy-src/actions/educationPeriod';

import { setItems as setItemsAction } from 'legacy-src/actions/classes';
import { savePreferenceSuccess as savePreferenceSuccessAction } from 'legacy-src/components/auth/actions';
import { withSavePreference } from 'legacy/src/components/util';
import setUserSubjectsAction from 'legacy-src/actions/userSubjects';
import FAQ from 'legacy-src/components/help/FAQ';
import ContactUs from 'legacy-src/components/help/ContactUs';
import useImpersonateModal from 'legacy-src/components/impersonating/hooks/useImpersonateModal';
import { get, uniqBy, omit } from 'lodash';
import AssignmentExampleModal from 'chameleon-src/components/assignments/AssignmentsContainer/AdminCoordinator/AssignmentExampleModal';
import ImpersonateSubjectSelector from 'legacy-src/components/impersonating/components/ImpersonateSubjectSelector';
import useAcademicYearSelection from './hooks/useAcademicYearSelection';
import CreateSharedAssessmentModal from 'chameleon-src/components/shared_assessments';
import { buildUrl } from 'legacy-src/utility/buildUrl';
import SharedAssessmentModal from 'chameleon/src/components/SharedAssessmentPage/SharedAssessmentModal';
import {
  fetchAssessmentSummary,
  updateQuizDescriptionAction,
} from 'chameleon/src/actions/assessmentSummary';
import InfoModalAutoAssignedPC from 'chameleon/src/components/InfoModalAutoAssignedPC';
import ButtonWithIcon from 'chameleon/ui-stack/ui/buttons/button-with-icon';

const ContainerWrapper = (WrappedComponent) => {
  const Wrapper = (props) => {
    const {
      userData,
      featureFlag,
      subjectData,
      params: { subject },
      routes,
      router,
      location: { query, pathname },
      impersonating,
      setUserSubjects,
      setItems,
      savePreference,
      savePreferenceSuccess,
      setDefaultEducationPeriodCode,
      client,
      assessmentSummaryData,
      assessmentSummaryFetching,
      assessmentSummaryFetched,
      updateQuizDescription,
      getAssessmentSummary,
      enableSharedAssessments,
      userTimezone,
    } = props;
    const [impersonateModal, openImpersonateModal] = useImpersonateModal();
    const [isLoading, setIsLoading] = useState(null);

    const {
      me,
      isTeacher,
      isAdmin,
      isCoordinator,
      educationPeriod,
      chosenEducationPeriodCode,
      teacherSubjects,
      adminSubjects,
    } = userData;
    const {
      schoolSet: [firstSchool],
    } = me;
    const { initId: schoolId } = firstSchool || {};

    const assessmentSummary = {
      ...assessmentSummaryData,
      isFetching: assessmentSummaryFetching,
      isFetched: assessmentSummaryFetched,
    };

    const { quizSummaryId } = query;

    const { educationPeriods } = educationPeriod;
    const { AP_AY_dropdown_at_top: APAYDropdownAtTop } = featureFlag;
    const chosenEducationPeriod = educationPeriods.find(
      ({ id }) => id === chosenEducationPeriodCode,
    );
    const subjectEducationPeriods = isTeacher
      ? getSubjectEducationPeriods({
          subjectId: subject,
          teacherSubjects,
        })
      : [];

    const subjectEducationPeriodsDeDup = uniqBy(
      subjectEducationPeriods,
      'displayValue',
    );

    const isAdminOrCoordinator = isAdmin || isCoordinator;

    const {
      preap_quick_tips: preapQuickTipsFlag,
      show_appcues_in_app_help: showAppcuesFlag,
      show_global_nav: showGlobalNavFlag,
      preap_teacher_impersonates_student: preapTeacherImpersonatesFlag,
      ap_teacher_impersonates_student: apTeacherImpersonatesFlag,
      preap_chameleon_app: preApChameleonFlag,
    } = featureFlag;

    const { onPeriodSelect, onSubjectClick, showAcademicYearSelector } =
      useAcademicYearSelection({
        client,
        setDefaultEducationPeriodCode,
        userData,
        setUserSubjects,
        setItems,
        savePreference,
        setIsLoading,
        savePreferenceSuccess,
        subject,
        APAYDropdownAtTop,
        subjectEducationPeriods,
        chosenEducationPeriod,
        preApChameleonFlag,
      });

    const { isPreApSubject } = subjectData;
    const preapQuickTips = isPreApSubject && preapQuickTipsFlag;
    const showQuickTipsForAtLeastOneProgram =
      showAppcuesFlag && (preapQuickTips || !isPreApSubject);
    const showQuickTips =
      showQuickTipsForAtLeastOneProgram &&
      !impersonating.isReadOnly &&
      !!subject;
    const isImpersonatingAvailable = isPreApSubject
      ? preapTeacherImpersonatesFlag
      : apTeacherImpersonatesFlag;
    const isImpersonating = impersonating.isReadOnly;
    const canImpersonate = isTeacher && isImpersonatingAvailable;

    const currentRoute = routes[routes.length - 1];
    const { leftNav = true } = currentRoute;

    const assignmentExampleType = get(query, ['assignmentExampleModal']);
    const shareAssessmentInviteItemId = get(query, [
      'shareAssessmentInviteItemId',
    ]);
    const assessmentTitle = get(query, ['assessmentTitle']);

    const onStudentViewClick = () => {
      openImpersonateModal();
    };

    const sharedInviteOnClickClose = () => {
      const newPathname = buildUrl(
        routes,
        null,
        router.params,
        omit(query, ['shareAssessmentInviteItemId', 'assessmentTitle']),
      );
      router.push(newPathname);
    };

    const currentSection = React.useMemo(
      () => me.sections.find((section) => section.masterSubjectId === subject),
      [me.sections, subject],
    );

    const isStudentViewAvailable =
      canImpersonate && !isImpersonating && Boolean(subject);

    const topNav = (
      <Fragment>
        {impersonateModal}
        {/* The modal informing students about the auto assigned PCs */}
        {/* Exclude Exam Only classes */}
        {userData.isStudent &&
          currentSection &&
          currentSection.sectionType !== 'EO' && (
            <InfoModalAutoAssignedPC
              userId={me.initId}
              schoolId={currentSection.parentId}
              subjectId={subject}
              isImpersonating={impersonating.isReadOnly}
              preferences={me.preferences}
              savePreference={savePreference}
            />
          )}
        {/* The modal informing students about the auto assigned PCs */}
        <div className="flex-grow">
          <div className="inline-flex">
            {leftNav && (
              <ImpersonateSubjectSelector
                userData={userData}
                impersonating={impersonating}
                apImpersonatingFlag={apTeacherImpersonatesFlag}
                preapImpersonatingFlag={preapTeacherImpersonatesFlag}
              >
                <SubjectSelector
                  userData={userData}
                  subject={subject}
                  onSubjectClick={onSubjectClick}
                />
              </ImpersonateSubjectSelector>
            )}
          </div>

          {showAcademicYearSelector && (
            <div className="inline-flex">
              {leftNav && (
                <AcademicYearSelector
                  onPeriodSelect={onPeriodSelect}
                  chosenEducationPeriodId={chosenEducationPeriod.id}
                  displayValue={chosenEducationPeriod.displayValue}
                  periods={subjectEducationPeriodsDeDup}
                />
              )}
            </div>
          )}
        </div>
        <div className="flex gap-6">
          {isStudentViewAvailable && leftNav && (
            <ButtonWithIcon
              isSecondary
              icon="library_add"
              onClick={onStudentViewClick}
            >
              Student View
            </ButtonWithIcon>
          )}
          {showQuickTips && !userData.isStudent && <QuickTips />}
          <HelpMenu
            pathname={pathname}
            userData={userData}
            subjectData={subjectData}
          >
            <FAQ
              subjectData={subjectData}
              isPreAPCoord={isAdminOrCoordinator}
            />
            <ContactUs
              router={router}
              buttonText={
                subjectData?.subjectProgram === 'PRE-AP'
                  ? 'Contact Us'
                  : 'AP Classroom Contact Us'
              }
            />
          </HelpMenu>
          {leftNav && (
            <UserMenu userData={userData} showGlobalNav={showGlobalNavFlag} />
          )}
        </div>
        {assignmentExampleType && (
          <AssignmentExampleModal
            assignmentExampleType={assignmentExampleType}
            router={router}
          />
        )}
        {shareAssessmentInviteItemId && (
          <CreateSharedAssessmentModal
            subject={subjectData.id}
            educationPeriod={
              chosenEducationPeriod ? chosenEducationPeriod.id : null
            }
            itemId={shareAssessmentInviteItemId}
            assessmentTitle={assessmentTitle}
            onClickClose={sharedInviteOnClickClose}
          />
        )}
        {enableSharedAssessments && quizSummaryId && (
          <SharedAssessmentModal
            itemData={assessmentSummary}
            getItemData={getAssessmentSummary}
            itemFetchId={quizSummaryId}
            router={router}
            subjectInfo={subjectData || {}}
            isTeacher={isTeacher}
            isAdmin={isAdmin}
            isCoordinator={isCoordinator}
            teacherSubjects={teacherSubjects}
            adminSubjects={adminSubjects}
            client={client}
            schoolId={schoolId}
            userTimezone={userTimezone}
            updateQuizDescription={updateQuizDescription}
          />
        )}
      </Fragment>
    );

    if (isLoading) {
      return <LoadingSpinner />;
    }

    return <WrappedComponent {...props} topNav={topNav} />;
  };

  const mapStateToProps = ({
    userData,
    impersonating,
    featureFlag,
    subject,
    assessmentSummary: {
      assessmentSummaryData,
      isFetching: assessmentSummaryFetching,
      isFetched: assessmentSummaryFetched,
      userTimezone,
    },
  }) => ({
    userData,
    impersonating,
    featureFlag,
    subjectData: subject.data,
    assessmentSummaryData,
    assessmentSummaryFetching,
    assessmentSummaryFetched,
    userTimezone,
    enableSharedAssessments: featureFlag.shared_assessments,
  });

  return compose(
    connect(mapStateToProps, {
      setItems: setItemsAction,
      setUserSubjects: setUserSubjectsAction,
      savePreferenceSuccess: savePreferenceSuccessAction,
      setDefaultEducationPeriodCode: setDefaultEducationPeriodCodeAction,
      getAssessmentSummary: fetchAssessmentSummary,
      updateQuizDescription: updateQuizDescriptionAction,
    }),
    withApollo,
    withSavePreference,
  )(Wrapper);
};

export default ContainerWrapper;
